import { MessageCircle, Phone } from "lucide-react";
import { track, whatsappLink } from "../lib/site";
import { useSite } from "../context/SiteContext";

export const FloatingCTA = () => {
  const { settings } = useSite();
  return (
    <div className="floating-cta" data-testid="floating-cta">
      <a
        href={whatsappLink("Hello Madhubhan Resort & Spa, I would like to enquire about a stay.", settings.whatsapp)}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="float-btn whatsapp"
        onClick={() => track("whatsapp_click", { location: "floating" })}
        data-testid="floating-whatsapp"
      >
        <MessageCircle size={21} />
      </a>
      <a
        href={`tel:${settings.phone_tel}`}
        aria-label="Call reservations"
        className="float-btn call"
        onClick={() => track("call_click", { location: "floating" })}
        data-testid="floating-call"
      >
        <Phone size={20} />
      </a>
    </div>
  );
};
